module.exports = __webpack_public_path__ + "static/media/evatic_logo.65b30142.png";